import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { updateBanca, getBanca } from '../../actions/BancasAction'
import Loading from '../../components/Loading'
import CabecalhoInterno from '../../components/CabecalhoInterno'
import ContainerInterno from '../../components/ContainerInterno'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import { Redirect } from "react-router"

class BancasEdit extends Component {

  state = {
    formNome: '',
    erro: null,
    erroShow: false
  }

  componentDidMount() {
    const { id } = this.props.match.params
    this.props.getBanca(id)
  }

  setError = (errorMessage = 'Erro ao tentar criar a banca.') => {
    this.setState({
      erro: errorMessage,
      erroShow: true
    })
    document.getElementsByClassName('containerInterno')[0].scrollTop = 0
    return false
  }

  formSubmit = (e) => {
    e.preventDefault()
    const { formNome } = this.state
    const { banca } = this.props.bancas
    const { id } = this.props.match.params
    var errorMessage = ""
    if (!formNome && !banca.nome) {
      errorMessage += "* Preencha o nome.<br />"
    }
    if (errorMessage !== "") {
      return this.setError(errorMessage)
    }
    const body = {
      nome: formNome ? formNome : banca.nome
    }
    this.props.updateBanca(this.props.login.accessToken, id, body)
  }

  render() {

    const { banca, loadBancas } = this.props.bancas
    const { redirectTo } = this.props.redirect
    const { formNome, erro, erroShow } = this.state

    if (loadBancas || !banca) {
      return (
        <Loading></Loading>
      )
    }

    if (redirectTo) {
      return (
        <Redirect to={redirectTo} />
      )
    }

    return (
      <div>
        <CabecalhoInterno history={this.props.history}>
          <h3>Editar Banca</h3>
        </CabecalhoInterno>
        <ContainerInterno>
          <Form onSubmit={this.formSubmit}>
            {erro && erroShow ? <Alert variant="danger" onClick={() => this.setState({erroShow: false})} ><div dangerouslySetInnerHTML={{ __html: erro }} /></Alert> : []}
            <Form.Group as={Row} controlId="formNome">
              <Form.Label column sm="1" className="text-right">
                Nome
              </Form.Label>
              <Col sm="11">
                <Form.Control
                  value={formNome ? formNome : banca.nome}
                  type="text"
                  name="nome"
                  onChange={e => this.setState({ formNome: e.target.value, erroShow: false })}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Col sm={{ span: 11, offset: 1 }}>
                <Button type="submit">Editar</Button>
              </Col>
            </Form.Group>
          </Form>
        </ContainerInterno>
      </div>
    )
  }
}

const mapStateToProps = state =>
  ({
    bancas: state.bancas,
    login: state.login,
    redirect: state.redirect
  })

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateBanca, getBanca }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(BancasEdit)